import {useEffect, useState} from "react";
import {app} from "@microsoft/teams-js";
import type {Theme} from "@fluentui/react-components";
import {themeFromTeamsThemeString} from "../utils/shellTheme.ts";

function readInitialThemeString(): string {
    return new URLSearchParams(window.location.search).get("theme") || "default";
}

/**
 * Teams host state for the admin tab: whether it runs inside Teams, and the Teams theme
 * (seeded from `?theme=`, then the Teams context, then live theme changes).
 */
export function useTeamsHost(): { loading: boolean; inTeams: boolean | undefined; theme: Theme; themeString: string } {
    const [loading, setLoading] = useState<boolean>(true);
    const [inTeams, setInTeams] = useState<boolean | undefined>(undefined);
    const [themeString, setThemeString] = useState<string>(readInitialThemeString);

    useEffect(() => {
        const applyTheme = (teamsTheme: string | undefined) => setThemeString(teamsTheme || "default");

        app.initialize()
            .then(() => app.getContext())
            .then(context => {
                setInTeams(true);
                applyTheme(context.app.theme);
                app.registerOnThemeChangeHandler(applyTheme);
            })
            .catch(() => setInTeams(false))
            .finally(() => setLoading(false));
    }, []);

    return {loading, inTeams, theme: themeFromTeamsThemeString(themeString), themeString};
}
